import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { classnames } from '@fmnts/common';
import { ThemeSize, ThemeSizeSmall } from '@fmnts/components';
import { htmlIdMaker } from '@fmnts/components/core';

const launcherLogoIds = htmlIdMaker('launcher-logo');

/**
 * Component that displays the Launcher (Next) app logo mark.
 */
@Component({
  selector: 'fmnts-launcher-logo',
  standalone: true,
  templateUrl: './launcher-logo.component.html',
  styleUrls: ['./launcher-logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClasses()',
  },
})
export class LauncherLogoComponent {
  private componentClass = 'launcher-logo';

  /** Unique id used to scope internal SVG references (mask/clipPath). */
  protected readonly uid = launcherLogoIds.next().value;

  /**
   * Used to control the size of the logo.
   * If not provided, the size will be determined by inheriting
   * the font-size.
   */
  readonly size = input<ThemeSizeSmall | ThemeSize>();

  protected readonly hostClasses = computed(() =>
    classnames([
      this.componentClass,
      this.size() && `${this.componentClass}--size-${this.size()}`,
    ]),
  );
}
